mdApp.controller('Main', ['$scope', '$element', function($scope, $element){
  	$scope.fields = {};
  	
  	var $_main_section = jQuery( $element[0] );
  	var $_footer = jQuery('#footer');
    var $_hero_section = jQuery('.hero-section');
  	var window_resize_main_timer = false;
  	
  	jQuery(window).on( 'resize', function(){
		clearTimeout( window_resize_main_timer );
		window_resize_main_timer = setTimeout( set_main_section_margin, 200);
  	})

  	function set_main_section_margin(){
        
        if( window.innerWidth <= 768 ){
            $_main_section.css({marginBottom:0,marginTop:0});
            jQuery('.hero-jump').css( { top : 'unset' } );
            return;
        }

		var footer_height = $_footer.outerHeight();
		$_main_section.css({marginBottom:footer_height});
      if( $_hero_section.hasClass('bg-image' )){
        // $_main_section.css({marginBottom:footer_height});
        return;
      }
      if( $_hero_section.length ){
          var hero_section_height = $_hero_section.outerHeight();
          $_main_section.css({marginTop:hero_section_height});
          // console.log('here');
          if( $_hero_section.hasClass('bg-video' ) ){
            var window_height = window.innerHeight;
            if( hero_section_height > window_height ){
              var threshold = (hero_section_height) - window_height; 
              jQuery('.hero-jump').css( { top : ( hero_section_height - threshold - 50 ) + 'px' } )
              console.log( '++' );
            }else{
              console.log( '--' );
              jQuery('.hero-jump').css( { top : ( hero_section_height - 50 ) + 'px' } )
            }
            console.log( window_height , hero_section_height, threshold );

          }
      }
  	}
	set_main_section_margin();
	
}]);